
export const links = [
  {
    id: 1,
    url: '/',
    text: 'Home',
  },
  {
    id: 2,
    url: '/about',
    text: 'About Me',
  },
  {
    id: 3,
    url: '/projects',
    text: 'Projects',
  },
  {
    id: 4,
    url: '/learning',
    text: 'Articles',
    submenu: [
      {
        title: 'Animation',
        url:'/animation'
      },
      {
        title: 'Rigging',
        url:'/rigging'
      },
    ]
  },
  {
    id: 5,
    url: '/services',
    text: 'Services',
    submenu: [
      {
        title: 'Animation',
        url:'/animation'
      },
      {
        title: 'Rigging',
        url:'/rigging'
      },
    ]
  },
  {
    id: 6,
    url: '/contact',
    text: 'Contact',
  },
];

export const projects = [
  {
    id: 1,
    title: 'Bachelor Thesis Project [RO]',
    img:'/images/licenta-icon.gif',
    desc: 'Simularea comportamentului dinamic al unui automobil in jocuri 3d'
  },
  {
    id: 2,
    title: 'Bachelor Thesis Project [RO]',
    img:'/images/licenta-icon.gif',
    desc: 'Simularea comportamentului dinamic al unui automobil in jocuri 3d'
  },
  {
    id: 3,
    title: 'Bachelor Thesis Project [RO]',
    img:'/images/licenta-icon.gif',
    desc: 'Simularea comportamentului dinamic al unui automobil in jocuri 3d'
  },
  {
    id: 4,
    title: 'Bachelor Thesis Project [RO]',
    img:'/images/licenta-icon.gif',
    desc: 'Simularea comportamentului dinamic al unui automobil in jocuri 3d'
  },
  
  
];

export const services = [
  {
    id: 1,
    title: 'Metin2 Assets',
    img:'/images/metin_logo.png',
    model:'/Models/war1.glb',
    desc: 'Animation and 3D design.',
    status: <span><i className="bi bi-0-circle"></i>Open</span>,
  }
];

export const learnings = [
  {
    id: 1,
    title: 'Lip Sync',
    img:'/images/lipsync.jpg',
    desc: 'Jason Osipa Technique'
  },
    {
    id: 2,
    title: 'The 12 principles of Animation',
    img:'/images/principles.jpg',
    desc: 'Principles of animation explained'
  },
  {
    id: 3,
    title: 'Range of Movement',
    img:'/images/rangeofmovement.jpg',
    desc: 'In this section you can find the range of movements in a humanoid body.'
  },
  {
    id: 4,
    title: 'Character Rigging',
    img:'/images/rigging.jpg',
    desc: 'What is Character rigging and how it works.'
  },
];

export const animations_mt2 = [
  {
    id: 18,
    category:"others",
    hashtag: "#mixamo",
    hashtag1: "",
    hashtag2:"#male #female",
    embedID:"lt7cRLUVVZY",
    title:"Drunk Animations",
    price:"40 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/drunk.png',
    dis: true,
  },
  {
    id: 17,
    category:"others",
    hashtag: "#myAnimation",
    hashtag1: "",
    hashtag2:"#male #female",
    embedID:"lt7cRLUVVZY",
    title:"Mogosu Move",
    price:"25 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/mogosu.png',
    dis: true,
  },
  {
    id: 16,
    category:"others",
    hashtag: "#myAnimation",
    hashtag1: "",
    hashtag2:"#male",
    embedID:"lt7cRLUVVZY",
    title:"Proposal Animation",
    price:"20 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/proposal.png',
    dis: true,
  },
  {
    id: 15,
    category:"others",
    hashtag: "",
    hashtag1: "",
    hashtag2:"#male#female",
    embedID:"ymDp2E543Vw",
    title:"Cash Cash",
    price:"30 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/cash.png',
    dis: true,
  },
  {
    id: 14,
    category:"mount",
    hashtag: "#mixamo",
    hashtag1: "",
    hashtag2:"#male#female",
    embedID:"dYYOva3pbgA",
    title:"Jump Animation",
    price:"20 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/none.png',
    dis: true,
  },
  {
    id: 13,
    category:"mount",
    hashtag: "#myAnimation",
    hashtag1: "",
    hashtag2:"#male#female",
    embedID:"ZRoD2YtBPsA",
    title:"Wings Mount",
    price:"100 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/wings.png',
    dis: true,
  },
  {
    id: 12,
    category:"dance",
    hashtag: "",
    hashtag1: "",
    hashtag2:"#male #female",
    embedID:"Mlcva7Flagc",
    title:"Shuffle Dance",
    price:"25 EUR",
    mediafire: "",
    mega:"",
    img:'/images/orange_justice.png',
    dis: true,
  },
  {
    id: 11,
    category:"dance",
    hashtag: "#mixamo",
    hashtag1: "",
    hashtag2:"#female",
    embedID:"8tHmaHj7JYE",
    title:"Samba Dance",
    price:"15 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/samba.png',
    dis: true,
  },
  {
    id: 10,
    category:"dance",
    hashtag: "#myAnimation",
    hashtag1: "",
    hashtag2:"#female",
    embedID:"rUevP_HHb1U",
    title:"Hip Sway",
    price:"25 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/hip_sway.png',
    dis: true,
  },
  
  {
    id: 9,
    category:"mount",
    hashtag: "#myAnimation",
    hashtag1: "",
    hashtag2:"#male#female",
    embedID:"1E8Pr0DN0sY",
    title:"Bike Mount",
    price:"100 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/bike_icon.png',
    dis: true,
  },
  {
    id: 8,
    category:"dance",
    hashtag: "#myAnimation",
    hashtag1: "",
    hashtag2:"#male #female",
    embedID:"l07-faRt5mo",
    title:"Boschetarii astia",
    price:"25 EUR",
    mediafire: "",
    mega:"",
    img:'./images/boschetarii.png',
    dis: true,
  },
  {
    id: 7,
    category:"dance",
    hashtag: "#myAnimation",
    hashtag1: "#custom",
    hashtag2:"#male #female",
    embedID:"hVpj2Of_P90",
    title:"Orange Justice Dance",
    price:"Ace2",
    mediafire: "Download",
    mega:"download",
    img:'/images/orange_justice.png',
    dis: true,
  },
 
  {
    id: 6,
    category:"dance",
    hashtag: "#myAnimation",
    hashtag1: "",
    hashtag2:"#male #female",
    embedID:"z8LLMXDPQz0",
    title:"Fisherman",
    price:"20 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/none.png',
    dis: true,
  },
  {
    id: 5,
    category:"dance",
    hashtag: "myAnimation",
    hashtag1: "",
    hashtag2:"#male",
    embedID:"qrJpkVllAoY",
    title:"Dansul lui Jador",
    price:"25 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/sunt_o_forta.png',
    dis: true,
  },
  {
    id: 4,
    category:"dance",
    hashtag: "myAnimation",
    hashtag1: "",
    hashtag2:"#male#female",
    embedID:"obz0pUjdUyU",
    title:"Flag Animation",
    price:"30 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/flag.png',
    dis: true,
  },

  {
    id: 3,
    category:"dance",
    hashtag: "#mixamo",
    hashtag1: "#test",
    hashtag2:"#male",
    embedID:"bsgEfpVWVHo",
    title:"Party Dance",
    price:"Free",
    mediafire: "download",
    mega:"download",
    img:'/images/house.png',
    dis: false,
  },
  {
    id: 2,
    category:"dance",
    hashtag: "#mixamo",
    hashtag1: "#test",
    hashtag2:"#male #female",
    embedID:"rfkv61Jcuts",
    title:"Macarena Dance",
    price:"Free",
    mediafire: "https://www.mediafire.com/file/z4u3memc8plphzp/macarena.rar/file",
    mega:"https://mega.nz/file/741yFLJC#i2TuEyEdsibpplgo9OsgZWzk0wbrgsRnhh5ApUepTPU",
    img:"/images/macarena.png",
    dis: false,
  },

   {
    id: 1,
    category:"dance",
    hashtag: "#mixamo",
    hashtag1: "#test",
    hashtag2:"#female",
    embedID:"BEeS1nIwSBM",
    title:"Candy Shop Dance",
    price:"Free",
    mediafire: "https://www.mediafire.com/file/bc24ad0k5z1o70g/candy.rar/file",
    mega:"https://mega.nz/file/f9MkkDCJ#kS1dMcvIJRvFzMXBa9TVwRp_AxasnKGcunidAf85uTo",
    img:'./images/dance2.png',
    dis: false,
  },
];

export const mounts=[
  {
    id: 11,
    category:"mount",
    hashtag: "#myAnimation",
    hashtag1: "",
    hashtag2:"#male#female",
    embedID:"B-iwqMtfE_Y",
    title:"Wings Mount",
    price:"100 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/custom_mount.jpg',
    dis: true,
  },
  {
    id: 10,
    category:"mount",
    hashtag: "#myAnimation",
    hashtag1: "",
    hashtag2:"#male#female",
    embedID:"FpgVM-UOWzw",
    title:"Wings Mount",
    price:"100 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/n_mount007.jpg',
    dis: true,
  },
  {
    id: 9,
    category:"mount",
    hashtag: "#myAnimation",
    hashtag1: "",
    hashtag2:"#male#female",
    embedID:"DK87jOZalqs",
    title:"Wings Mount",
    price:"100 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/n_mount006.jpg',
    dis: true,
  },
  {
    id: 8,
    category:"mount",
    hashtag: "#myAnimation",
    hashtag1: "",
    hashtag2:"#male#female",
    embedID:"4m_9mRZq36w",
    title:"Wings Mount",
    price:"100 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/n_mount005.jpg',
    dis: true,
  },
  {
    id: 7,
    category:"mount",
    hashtag: "#myAnimation",
    hashtag1: "",
    hashtag2:"#male#female",
    embedID:"8ZhrE-TVnJg",
    title:"Wings Mount",
    price:"100 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/n_mount004.jpg',
    dis: true,
  },
  {
    id: 6,
    category:"mount",
    hashtag: "#myAnimation",
    hashtag1: "",
    hashtag2:"#male#female",
    embedID:"rJ2OwnGJVwc",
    title:"Wings Mount",
    price:"100 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/n_mount003.jpg',
    dis: true,
  },
  {
    id: 5,
    category:"mount",
    hashtag: "#myAnimation",
    hashtag1: "",
    hashtag2:"#male#female",
    embedID:"B-iwqMtfE_Y",
    title:"Wings Mount",
    price:"100 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/n_mount002.jpg',
    dis: true,
  },
  {
    id: 4,
    category:"mount",
    hashtag: "#myAnimation",
    hashtag1: "",
    hashtag2:"#male#female",
    embedID:"B-iwqMtfE_Y",
    title:"Wings Mount",
    price:"100 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/n_mount001.jpg',
    dis: true,
  },
  {
    id: 3,
    category:"mount",
    hashtag: "#myAnimation",
    hashtag1: "",
    hashtag2:"#male#female",
    embedID:"A2bSZOumtpU",
    title:"Wings Mount",
    price:"100 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/s_mount003.jpg',
    dis: true,
  },
  {
    id: 2,
    category:"mount",
    hashtag: "#myAnimation",
    hashtag1: "",
    hashtag2:"#male#female",
    embedID:"ZRoD2YtBPsA",
    title:"Wings Mount",
    price:"100 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/s_mount002.jpg',
    dis: true,
  },
  {
      id: 1,
      category:"mount",
      hashtag: "#myAnimation",
      hashtag1: "",
      hashtag2:"#male#female",
      embedID:"K_OCHBy8DAI",
      title:"Bike Mount",
      price:"100 EUR",
      mediafire: "Download",
      mega:"download",
      img:'/images/items/s_mount001.jpg',
      dis: true,
  }
];

export const dances1=[
  {
    id: 18,
    category:"others",
    hashtag: "#mixamo",
    hashtag1: "",
    hashtag2:"#male #female",
    embedID:"NmfErm9cV5s",
    title:"Drunk Animation",
    price:"40 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/drunk.png',
    dis: true,
  },
  {
    id: 17,
    category:"others",
    hashtag: "#myAnimation",
    hashtag1: "",
    hashtag2:"#male #female",
    embedID:"CW3kyMBG8fs",
    title:"Mogosu Move",
    price:"25 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/mogosu.png',
    dis: true,
  },
  {
    id: 16,
    category:"dance",
    hashtag: "",
    hashtag1: "",
    hashtag2:"#male #female",
    embedID:"JVSp3SI7uBo",
    title:"Sitting Animation",
    price:"30 EUR",
    mediafire: "",
    mega:"",
    img:'/images/sit.png',
    dis: true,
  },
  {
  
    id: 15,
    category:"dance",
    hashtag: "#myAnimation",
    hashtag1: "",
    hashtag2:"#male #female",
    embedID:"Y54HKzVGIZM",
    title:"Made in Romania Dance",
    price:"30 EUR",
    mediafire: "",
    mega:"",
    img:'/images/made_in_ro.png',
    dis: true,
  },
  {
    id: 14,
    category:"others",
    hashtag: "#myAnimation",
    hashtag1: "",
    hashtag2:"#male",
    embedID:"lt7cRLUVVZY",
    title:"Proposal Animation",
    price:"20 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/proposal.png',
    dis: true,
  },
  {
    id: 13,
    category:"others",
    hashtag: "",
    hashtag1: "",
    hashtag2:"#male#female",
    embedID:"ymDp2E543Vw",
    title:"Cash Cash",
    price:"30 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/cash.png',
    dis: true,
  },
  {
    id: 12,
    category:"mount",
    hashtag: "#mixamo",
    hashtag1: "",
    hashtag2:"#male#female",
    embedID:"dYYOva3pbgA",
    title:"Jump Animation",
    price:"20 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/none.png',
    dis: true,
  },
  {
    id: 11,
    category:"dance",
    hashtag: "myAnimation",
    hashtag1: "",
    hashtag2:"#male#female",
    embedID:"obz0pUjdUyU",
    title:"Flag Animation",
    price:"30 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/flag.png',
    dis: true,
  },

{
  
  id: 10,
  category:"dance",
  hashtag: "",
  hashtag1: "",
  hashtag2:"#male #female",
  embedID:"Mlcva7Flagc",
  title:"Shuffle Dance",
  price:"25 EUR",
  mediafire: "",
  mega:"",
  img:'/images/orange_justice.png',
  dis: true,
},
{
  id: 9,
  category:"dance",
  hashtag: "#mixamo",
  hashtag1: "",
  hashtag2:"#female",
  embedID:"8tHmaHj7JYE",
  title:"Samba Dance",
  price:"15 EUR",
  mediafire: "Download",
  mega:"download",
  img:'/images/samba.png',
  dis: true,

},
{
  id: 8,
  category:"dance",
  hashtag: "#myAnimation",
  hashtag1: "",
  hashtag2:"#female",
  embedID:"rUevP_HHb1U",
  title:"Hip Sway",
  price:"25 EUR",
  mediafire: "Download",
  mega:"download",
  img:'/images/hip_sway.png',
  dis: true,
},
{
  id: 7,
  category:"dance",
  hashtag: "#myAnimation",
  hashtag1: "",
  hashtag2:"#male #female",
  embedID:"l07-faRt5mo",
  title:"Boschetarii astia",
  price:"25 EUR",
  mediafire: "",
  mega:"",
  img:'./images/boschetarii.png',
  dis: true,
},
{
  id: 6,
  category:"dance",
  hashtag: "#myAnimation",
  hashtag1: "#custom",
  hashtag2:"#male #female",
  embedID:"hVpj2Of_P90",
  title:"Orange Justice Dance",
  price:"25 EUR",
  mediafire: "Download",
  mega:"download",
  img:'/images/orange_justice.png',
  dis: true,
},

{
  id: 5,
  category:"dance",
  hashtag: "#myAnimation",
  hashtag1: "",
  hashtag2:"#male #female",
  embedID:"z8LLMXDPQz0",
  title:"Fisherman",
  price:"20 EUR",
  mediafire: "Download",
  mega:"download",
  img:'/images/none.png',
  dis: true,
},
{
  id: 4,
  category:"dance",
  hashtag: "myAnimation",
  hashtag1: "",
  hashtag2:"#male",
  embedID:"qrJpkVllAoY",
  title:"Dansul lui Jador",
  price:"25 EUR",
  mediafire: "Download",
  mega:"download",
  img:'/images/sunt_o_forta.png',
  dis: true,
},
{
  id: 3,
  category:"dance",
  hashtag: "#mixamo",
  hashtag1: "#test",
  hashtag2:"#male",
  embedID:"bsgEfpVWVHo",
  title:"Party Dance",
  price:"Free",
  mediafire: "download",
  mega:"download",
  img:'/images/house.png',
  dis: false,
},
{
  id: 2,
  category:"dance",
  hashtag: "#mixamo",
  hashtag1: "#test",
  hashtag2:"#male #female",
  embedID:"rfkv61Jcuts",
  title:"Macarena Dance",
  price:"Free",
  mediafire: "https://www.mediafire.com/file/z4u3memc8plphzp/macarena.rar/file",
  mega:"https://mega.nz/file/741yFLJC#i2TuEyEdsibpplgo9OsgZWzk0wbrgsRnhh5ApUepTPU",
  img:"/images/macarena.png",
  dis: false,
},

 {
  id: 1,
  category:"dance",
  hashtag: "#mixamo",
  hashtag1: "#test",
  hashtag2:"#female",
  embedID:"BEeS1nIwSBM",
  title:"Candy Shop Dance",
  price:"Free",
  mediafire: "https://www.mediafire.com/file/bc24ad0k5z1o70g/candy.rar/file",
  mega:"https://mega.nz/file/f9MkkDCJ#kS1dMcvIJRvFzMXBa9TVwRp_AxasnKGcunidAf85uTo",
  img:'./images/dance2.png',
  dis: false,
}
];

export const pets=[
  {
    id: 10,
    category:"pet",
    hashtag: "#pet",
    hashtag1: "",
    hashtag2:"",
    embedID:"tHStn4VqSzg",
    title:"Fairy Pet",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/custom_pet.jpg',
    dis: true,
  },
  {
    id: 9,
    category:"pet",
    hashtag: "#pet",
    hashtag1: "",
    hashtag2:"",
    embedID:"A9KAGrvDFAQ",
    title:"Fairy Pet",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/pet009.jpg',
    dis: true,
  },
  {
    id: 8,
    category:"pet",
    hashtag: "#pet",
    hashtag1: "",
    hashtag2:"",
    embedID:"tHStn4VqSzg",
    title:"Fairy Pet",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/pet008.jpg',
    dis: true,
  },
  {
    id: 7,
    category:"pet",
    hashtag: "#pet",
    hashtag1: "",
    hashtag2:"",

    embedID:"yRAYa2AJvwY",
    title:"Fairy Pet",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/pet007.jpg',
    dis: true,
  },
  {
    id: 6,
    category:"pet",
    hashtag: "#pet",
    hashtag1: "",
    hashtag2:"",
    embedID:"C8a3iY8dymA",
    title:"Fairy Pet",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/pet006.jpg',
    dis: true,
  },
  {
    id: 5,
    category:"pet",
    hashtag: "#pet",
    hashtag1: "",
    hashtag2:"",
    embedID:"02MGEqUginY",
    title:"Fairy Pet",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/pet005.jpg',
    dis: true,
  },
  {
    id: 4,
    category:"pet",
    hashtag: "#pet",
    hashtag1: "",
    hashtag2:"",
    embedID:"02MGEqUginY",
    title:"Fairy Pet",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/pet004.jpg',
    dis: true,
  },
  {
    id: 3,
    category:"pet",
    hashtag: "#pet",
    hashtag1: "",
    hashtag2:"",
    embedID:"3bWgql-B3Yk",
    title:"Fairy Pet",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/pet003.jpg',
    dis: true,
  },
  {
    id: 2,
    category:"pet",
    hashtag: "#pet",
    hashtag1: "",
    hashtag2:"",
    embedID:"tjLpxMJmj4k",
    title:"Mickey & Minnie Mouse Pet",
    price:"40 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/pet002.jpg',
    dis: true,
  },
  {
  id: 1,
  category:"pet",
  hashtag: "#pet",
  hashtag1: "",
  hashtag2:"",
  embedID:"tjLpxMJmj4k",
  title:"Kitty Pets",
  price:"50 EUR",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/pet001.jpg',
  dis: true,
},
];
export const costumes=[
  {
  id: 157,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"",
  embedID:"0G49NCzcqTU",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/custom_outfit.jpg',
  dis: true,
},
{
  id: 156,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"sf",
  embedID:"u2VPbE1Suno",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c156sf.jpg',
  dis: true,
},
{
  id: 155,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"sf",
  embedID:"Q38zsCRcXog",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c155sf.jpg',
  dis: true,
},
{
  id: 154,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"sm",
  embedID:"LFU6mC_8UV4",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c154sm.jpg',
  dis: true,
},
  {
  id: 153,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"sm",
  embedID:"wWVuqQGnN4c",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c153sm.jpg',
  dis: true,
},
  {
  id: 152,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"f0V149xZO9g",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c152shf.jpg',
  dis: true,
},
{
  id: 151,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"lKCntEglF9U",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c151shf.jpg',
  dis: true,
},
{
  id: 150,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"sf",
  embedID:"uGlnT7f_h-Y",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c150sf.jpg',
  dis: true,
},
{
  id: 149,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"uXilEFdGi1w",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c149shf.jpg',
  dis: true,
},
{
  id: 148,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"0G49NCzcqTU",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c148shf.jpg',
  dis: true,
    colors: [
    { name: "Dark Blue", hex: "#535ed3", img: '/images/items/c148shf_v1.jpg', embedID: "Uessn64PPGw" },
    { name: "Green", hex: "#0d1b05", img: '/images/items/c148shf_v2.jpg', embedID: "6176ng1hX1Y" },
  ]
},
{
  id: 147,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"sm",
  embedID:"nXuQNM3Eb9g",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c147sm.jpg',
  dis: true,
      colors: [
    { name: "Green", hex: "#335736", img: '/images/items/c147sm.jpg', embedID: "nXuQNM3Eb9g" },
    { name: "Black", hex: "#000000", img: '/images/items/c147sm_v2.jpg', embedID: "EIgRbkZIHxo" },
  ]
},
{
  id: 146,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"QdvNycMHTnI",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c146shf.jpg',
  dis: true,
},
{
  id: 145,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shm",
  embedID:"0G49NCzcqTU",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c145shm.jpg',
  dis: true,
},
{
  id: 144,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"lamdxNW2On4",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c144shf.jpg',
  dis: true,
},
{
  id: 143,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"1as-ZTgf7hg",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c143shf.jpg',
  dis: true,
},
{
  id: 142,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"BWcH-EVh37w",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c142shf.jpg',
  dis: true,
},
{
  id: 141,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"nm",
  embedID:"2n33J6yf2ro",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c141nm.jpg',
  dis: true,
},
{
  id: 140,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"2n33J6yf2ro",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c140shf.jpg',
  dis: true,
},
{
  id: 139,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"nm",
  embedID:"x1bgYj59lrg",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/custom_outfit.jpg',
  dis: true,
    colors: [

    { name: "Dark Blue", hex: "#03051b", img: '/images/items/c139nm_v1.jpg', embedID: "vZLLxbD4rSA" },
    { name: "Green", hex: "#0a1a01", img: '/images/items/c139nm_v2.jpg', embedID: "u3RdvPPZtaw" },
    { name: "Purple", hex: "#26081c", img: '/images/items/c139nm_v3.jpg', embedID: "tZmWIclN_KU" },
    { name: "White Purple", hex: "#191025", img: '/images/items/c139nm_v4.jpg', embedID: "L9oiI1XBgWw" },
    { name: "Black", hex: "#000000", img: '/images/items/c139nm_v5.jpg', embedID: "zSCLVM4LN90" },
    { name: "Light Blue", hex: "#8db1e7", img: '/images/items/c139nm_v6.jpg', embedID: "d2O80_ZEabw" },
    { name: "White", hex: "#ffffff", img: '/images/items/c139nm_v7.jpg', embedID: "RN2fwgc3i5Q?" },
    { name: "Red", hex: "#4e0505", img: '/images/items/c139nm_v8.jpg', embedID: "TDVwFg3OjDs" },
  ]
},
{
  id: 138,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"rfb2OFozZ4U",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c138shf.jpg',
  dis: true,
},
{
  id: 137,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"sf",
  embedID:"mUJ9DzXRgJ0",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c137sf.jpg',
  dis: true,
},
{
  id: 136,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"sf",
  embedID:"kb4m7Gcp2y0",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c136sf.jpg',
  dis: true,
},
{
  id: 135,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"sf",
  embedID:"eHCbDGdwefA",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c135sf.jpg',
  dis: true,
},
{
  id: 134,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"x1bgYj59lrg",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/custom_outfit.jpg',
  dis: true,
    colors: [

    { name: "Purple", hex: "#470b4a", img: '/images/items/c134shf_v1.jpg', embedID: "OYDgLR1XfX8" },
    { name: "Pink", hex: "#c4a2d9", img: '/images/items/c134shf_v2.jpg', embedID: "B8mZlW3VzHg" },
    { name: "Bluish", hex: "#0d1e32", img: '/images/items/c134shf_v3.jpg', embedID: "37TXuFRsGj8" },
    { name: "Blue", hex: "#182d6b", img: '/images/items/c134shf_v4.jpg', embedID: "cHDbk74gyhg" },
    { name: "Red", hex: "#3d0f1c", img: '/images/items/c134shf_v5.jpg', embedID: "xiI2880MZDU" },
    { name: "Whitesmoke", hex: "#83828d", img: '/images/items/c134shf_v6.jpg', embedID: "zp8hIvK3lUw" },
    { name: "Black", hex: "#0f0e10", img: '/images/items/c134shf_v7.jpg', embedID: "ADf-yNGqoDc" },
  ]
},
{
  id: 133,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"x1bgYj59lrg",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/custom_outfit.jpg',
  dis: true,
    colors: [
    { name: "Cream", hex: "#ccb6b6", img: '/images/items/c133shf_v1.jpg', embedID: "jmeb2sq6Mms" },
    { name: "Purple", hex: "#751ba1", img: '/images/items/c133shf_v2.jpg', embedID: "Ms1xzcYMJuE" },
    { name: "Red", hex: "#240000", img: '/images/items/c133shf_v3.jpg', embedID: "uQl5gmdyOjc" },
    { name: "Multicolor", hex: "#260e47", img: '/images/items/c133shf_v4.jpg', embedID: "R486WGp6W1k" },
    { name: "Bluish", hex: "#1b202b", img: '/images/items/c133shf_v5.jpg', embedID: "gC4Wh_6Ez6Y" },
    { name: "Green", hex: "#041f27", img: '/images/items/c133shf_v6.jpg', embedID: "_v5pL2oQoGA" },
    { name: "Pink", hex: "#8e4e94", img: '/images/items/c133shf_v7.jpg', embedID: "qge5EcoacrQ" },
  ]
},
{
  id: 132,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"x1bgYj59lrg",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/custom_outfit.jpg',
  dis: true,
    colors: [
    { name: "Black", hex: "#060606", img: '/images/items/c132shf.jpg', embedID: "_x_NLDrmZ1s" },
    { name: "Cream", hex: "#ccb6b6", img: '/images/items/c132shf_v2.jpg', embedID: "ZIPyEPoMvCk" },
    { name: "Blue", hex: "#3b4574", img: '/images/items/c132shf_v3.jpg', embedID: "sa1h9bUG3wU" },
    { name: "Red", hex: "#240000", img: '/images/items/c132shf_v4.jpg', embedID: "huDCp_N8G-k" },
    { name: "Baby Blue", hex: "#56637f", img: '/images/items/c132shf_v5.jpg', embedID: "r4iZ_g6EOrc" },
    { name: "Purple", hex: "#624669", img: '/images/items/c132shf_v6.jpg', embedID: "VA6sUJ8Itv4" },
    { name: "White", hex: "#a3a0a3", img: '/images/items/c132shf_v7.jpg', embedID: "JGG5dWPSxQw" },
    { name: "Multicolor", hex: "#2e1521", img: '/images/items/c132shf_v8.jpg', embedID: "T_Mr8RGi6es" },
  ]
},
{
  id: 131,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shm",
  embedID:"1UQoRxXqnkc",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c131shm.jpg',
  dis: true,
},
{
  id: 130,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"x1bgYj59lrg",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/custom_outfit.jpg',
  dis: true,
    colors: [
    { name: "Black", hex: "#060606", img: '/images/items/c130shf.jpg', embedID: "JQJwGj8MLeA" },
    { name: "Red", hex: "#590101", img: '/images/items/c130shf_v3.jpg', embedID: "aTQZAmEGI5k" },
    { name: "Cream", hex: "#a69282", img: '/images/items/c130shf_v4.jpg', embedID: "wecT_tjSHks" },
      { name: "Pink", hex: "#a86164", img: '/images/items/c130shf_v5.jpg', embedID: "yQEoiaSThfM" },
    { name: "Green", hex: "#1c291e", img: '/images/items/c130shf_v6.jpg', embedID: "fsiDKR_NWa0" },
    { name: "Blue", hex: "#2f474a", img: '/images/items/c130shf_v7.jpg', embedID: "w3wq_0lgrhI" },
    { name: "White", hex: "#d1d1d1", img: '/images/items/c130shf_v8.jpg', embedID: "AhXq1BHN9gM" },
    { name: "Dark Red", hex: "#270202", img: '/images/items/c130shf_v9.jpg', embedID: "usDSvSfO940" },
  ]
},
{
  id: 129,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"by0Mavy9HDw",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c129shf.jpg',
  dis: true,
},
{
  id: 128,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"QS91pU2bA3g",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c128shf.jpg',
  dis: true,
},
{
  id: 127,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"nm",
  embedID:"BJjb9x7Ny18",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c127nm.jpg',
  dis: true,
},
{
  id: 126,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"BJjb9x7Ny18",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c126shf.jpg',
  dis: true,
},
{
  id: 125,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"HQEBCgnj0K0",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c125shf.jpg',
  dis: true,
},

  {
  id: 124,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"DAHB_YWKhvs",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c124shf.jpg',
  dis: true,
},
{
  id: 123,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"nm",
  embedID:"DAHB_YWKhvs",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c123nm.jpg',
  dis: true,
      colors: [
    { name: "Black", hex: "#060606", img: '/images/items/c123nm.jpg', embedID: "DAHB_YWKhvs" },
    { name: "White", hex: "#dbd8d8", img: '/images/items/c123nm_v2.jpg', embedID: "mUJ9DzXRgJ0" },
  ]
},
  {
  id: 122,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"Ushgstoi1aY",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c122shf.jpg',
  dis: true,
},
  {
  id: 121,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"atkcergTXPY",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c121shf.jpg',
  dis: true,
},
{
  id: 120,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"x1bgYj59lrg",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c120shf.jpg',
  dis: true,
},
{
  id: 119,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"tEgasqeu4iQ",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c119shf.jpg',
  dis: true,
},
{
  id: 118,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"XkeF0_38erI",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c118shf.jpg',
  dis: true,
},
{
  id: 117,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"wm",
  embedID:"GJYw-0Al0O4",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c117wm.jpg',
  dis: true,
},
{
  id: 116,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"Hb7AsXuH5mM",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c116shf.jpg',
  dis: true,
},
{
  id: 115,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"wm",
  embedID:"PKyzOJAS7QE",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c115wm.jpg',
  dis: true,
},
{
  id: 114,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"S4b1UPOAzqY",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c114shf.jpg',
  dis: true,
},
{
  id: 113,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"wm",
  embedID:"A9mj_wyUxFk",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c113wm.jpg',
  dis: true,
},
{
  id: 112,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"wm",
  embedID:"W3Sqc-eB5RQ",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c112wm.jpg',
  dis: true,
},
    {
  id: 111,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"nm",
  embedID:"KX4dWVNX-cE",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c111nm.jpg',
  dis: true,
},
{
  id: 110,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"JRmsRwvKCn8",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c110shf.jpg',
  dis: true,
},
{
  id: 109,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2: "sf",
  embedID:"IoxXs3t6d2s",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c109sf.jpg',
  dis: true,
},
  
  {
  id: 108,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"MQtD7YkEH7A",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c108shf.jpg',
  dis: true,
},
  {
  id: 107,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"wm",
  embedID:"ZHiYID2puFA",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c107wm.jpg',
  dis: true,
},
  {
  id: 106,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"wm",
  embedID:"qMPlkSMyuDE",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c106wm.jpg',
  dis: true,
},
  {
  id: 105,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"p5emoaEgf0c",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c105shf.jpg',
  dis: true,
},
{
  id: 104,
  category:"costumes",
  hashtag: "",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"UdYVB9cKUF4",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c104shf.jpg',
  dis: true,
},
    {
    id: 103,
    category:"costumes",
    hashtag: "",
    hashtag1: "",
    hashtag2:"shm",
    embedID:"emHPf3R2l4Q",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c103shm.jpg',
    dis: true,
  },
  {
    id: 102,
    category:"costumes",
    hashtag: "",
    hashtag1: "",
    hashtag2:"shm",
    embedID:"vX4MXBuC0hs",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c102shm.jpg',
    dis: true,
  },
  {
    id: 101,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"mmtacOUDlNc",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c101shf.jpg',
    dis: true,
  },
    {
    id: 100,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"wm",
    embedID:"6XXhLMBfF7s",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c100wm.jpg',
    dis: true,
  },
  {
    id: 99,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"A0xrKo0J1fw",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c99shf.jpg',
    dis: true,
  },
  {
    id: 98,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"bjqYicqKsic",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c98shf.jpg',
    dis: true,
    colors: [
    { name: "Black", hex: "#bb3602", img: '/images/items/c98shf.jpg', embedID: "bjqYicqKsic" },
    { name: "White", hex: "#5a0606", img: '/images/items/c98shf_v2.jpg', embedID: "WhU3t2o4Boo" },
    { name: "White", hex: "#000000", img: '/images/items/c98shf_v3.jpg', embedID: "Zx1F36O6Rzg" }
  ]
  },
  {
    id: 97,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"nm",
    embedID:"8EGOAFx47hU",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c97nm.jpg',
    dis: true,
  },
  {
    id: 96,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"JpjSpMkHQvk",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c96shf.jpg',
    dis: true,
  },
      {
    id: 95,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"399jo6LrEbw",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c95shf.jpg',
    dis: true,
  },
    {
    id: 94,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shm",
    embedID:"7h7GrvpPNa0",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c94shm.jpg',
    dis: true,
  },
      {
    id: 93,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"sm",
    embedID:"VP3RVhWiCAE",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c89sm.jpg',
    dis: true,
  },
    {
    id: 92,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"tAuX6XNp5DY",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c87shf.jpg',
    dis: true,
  },
    {
    id: 91,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"eJABdH9w6Cs",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c83shf.jpg',
    dis: true,
  },
    {
    id: 90,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shm",
    embedID:"KKlDqunszvk",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c90shm.jpg',
    dis: true,
  },
    {
    id: 89,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"sm",
    embedID:"45O3X4bwEzM",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c86sm.jpg',
    dis: true,
  },
    {
    id: 88,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"ONfCZFBAve4",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c85shf.jpg',
    dis: true,
  },
      {
    id: 87,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"te0XAtUMtx4",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c84shf.jpg',
    dis: true,
  },
    {
    id: 86,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"nm",
    embedID:"eoY8huylwiU",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c82nm.jpg',
    dis: true,
  },
    {
    id: 85,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shm",
    embedID:"vuUAp17hCa4",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c76shm.jpg',
    dis: true,
  },
    {
    id: 84,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"nm",
    embedID:"TovMzh61ews",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c81nm.jpg',
    dis: true,
  },
    {
    id: 83,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"32_j3_60vBM",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c79shf.jpg',
    dis: true,
  },
  {
    id: 82,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"nd4U1sEUFuY",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c80shf.jpg',
    dis: true,
  },
    {
    id: 81,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"sf",
    embedID:"lr-8K7qGwBo",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c78sf.jpg',
    dis: true,
  },
    {
    id: 80,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"wm",
    embedID:"sH-Jz8ZPqFA",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c75wm.jpg',
    dis: true,
  },
  {
    id: 79,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"sf",
    embedID:"CN2MBeSf6m8",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c77sf.jpg',
    dis: true,
  },
    {
    id: 78,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"nf",
    embedID:"X2Fw5S2X-2k",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c72nf.jpg',
    dis: true,
  },
  {
    id: 77,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shm",
    embedID:"oYCqMdd3XNo",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c74shm.jpg',
    dis: true,
  },
  {
    id: 76,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"oYCqMdd3XNo",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c73shf.jpg',
    dis: true,
  },
  {
    id: 75,
    category:"costumes",
    hashtag: "",
    hashtag1: "",
    hashtag2:"nm",
    embedID:"U_E2sawFz5A",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c71nm.jpg',
    dis: true,
  },
  {
    id: 74,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"0ClluU8CYcc",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c70shf.jpg',
    dis: true,
  },
  {
    id: 73,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"rA8ldqqMEKE",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c69shf.jpg',
    dis: true,
  },
  {
    id: 72,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"nsP_wPnln8s",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c67shf.jpg',
    dis: true,
  },
  {
    id: 71,
    category:"costumes",
    hashtag: "ninja #male",
    hashtag1: "",
    hashtag2:"nm",
    embedID:"DAAQkBcaT_E",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c68nm.jpg',
    dis: true,
  },
  {
    id: 70,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"t4FI4GT-A5A",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c66shf.jpg',
    dis: true,
  },
  {
    id: 69,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"-GeyNjF-E5w",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c58shf.jpg',
    dis: true,
  },
  {
    id: 68,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"Fp9uS41ZZ7Q",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c65shf_p.jpg',
    dis: true,
  },
  {
    id: 67,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"QQ1oCb-cvwg",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c65shf_y.jpg',
    dis: true,
  },
  {
    id: 66,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"IE8JhHfFN9M",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c64shf.jpg',
    dis: true,
  },
  {
    id: 65,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"nf",
    embedID:"W2h2KVrnKWI",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c63nf.jpg',
    dis: true,
  },
  {
    id: 64,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"nm",
    embedID:"YfS05aIHaxU",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c62nm.jpg',
    dis: true,
  },
  {
    id: 63,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"ewAXQPy6iJk",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c63shf.jpg',
    dis: true,
  },
  {
    id: 62,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"bJGF1_vB0LM",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c61shf.jpg',
    dis: true,
  },
  {
    id: 61,
    category:"costumes",
    hashtag: "#ninja #female",
    hashtag1: "",
    hashtag2:"nf",
    embedID:"ST2NZrLgEEI",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c62nf.jpg',
    dis: true,
  },
  {
    id: 60,
    category:"costumes",
    hashtag: "#shaman #male",
    hashtag1: "",
    hashtag2:"shm",
    embedID:"L-De0bmf5Po",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c60shm.jpg',
    dis: true,
  },
  {
    id: 59,
    category:"costumes",
    hashtag: "#war #male",
    hashtag1: "",
    hashtag2:"wm",
    embedID:"ZqhNSJkIGvQ",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c59wm.jpg',
    dis: true,
  },
  {
    id: 58,
    category:"costumes",
    hashtag: "#ninja #female",
    hashtag1: "",
    hashtag2:"nf",
    embedID:"sOBYyZR2dt8",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c58nf.jpg',
    dis: true,
  },
  {
    id: 57,
    category:"costumes",
    hashtag: "#shaman #male",
    hashtag1: "",
    hashtag2:"shm",
    embedID:"vVmICazTdzU",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c57shm.jpg',
    dis: true,
  },
  {
    id: 56,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"Zg3Zn3TXh10",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c55shf.jpg',
    dis: true,
  },
  {
    id: 55,
    category:"costumes",
    hashtag: "#ninja #male",
    hashtag1: "",
    hashtag2:"nm",
    embedID:"XkiazRxSdCg",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c07nm.jpg',
    dis: true,
  },
  {
    id: 54,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"sf",
    embedID:"Z3sE-kvoRno",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c54sf.jpg',
    dis: true,
  },
  {
    id: 53,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"nf",
    embedID:"AySad46ua1Y",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c52nf.jpg',
    dis: true,
  },
  {
    id: 52,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shm",
    embedID:"JCR_kfrVEB4",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c51shm.jpg',
    dis: true,
  },
  {
    id: 51,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"6_Y82XNaWco",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c50shf.jpg',
    dis: true,
  },
  {
    id: 50,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"wV5vpmuM5B8",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c49shf.jpg',
    dis: true,
  },
  {
    id: 49,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"nm",
    embedID:"MX6z_6DvjuY",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c36nm.jpg',
    dis: true,
  },
  {
    id: 48,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"GYhLBu7G1N4",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c45shf.jpg',
    dis: true,
  },
  {
    id: 47,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"sm",
    embedID:"gwXl1DXMiYw",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c44sm.jpg',
    dis: true,
  },
  {
    id: 46,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"OTKwhUhTxpQ",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c43shf.jpg',
    dis: true,
  },
  {
    id: 45,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"wm",
    embedID:"HXbjaZXh4Zc",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c42wm.jpg',
    dis: true,
  },
  {
    id: 44,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"sm",
    embedID:"8yAS1d6jB9k",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c43sm.jpg',
    dis: true,
  },
  {
    id: 43,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"wm",
    embedID:"HE9NI5VSAYI",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c43wm.jpg',
    dis: true,
  },
  {
    id: 42,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shm",
    embedID:"hbDl0Zecx90",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c41shm.jpg',
    dis: true,
  },
  {
    id: 41,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"8YPdzSj3z5k",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c33shf.jpg',
    dis: true,
  },
  {
    id: 40,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"nm",
    embedID:"6ielZe5atM4",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c35nm.jpg',
    dis: true,
  },
  {
    id: 39,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"sm",
    embedID:"vYUHTAY0cOQ",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c34sm.jpg',
    dis: true,
  },

  {
    id: 38,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"wf",
    embedID:"JXLjRpibbso",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c00wf.jpg',
    dis: true,
  },
  {
    id: 37,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"nm",
    embedID:"7wggg5rjAOY",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c06nm.jpg',
    dis: true,
  },
  {
    id: 36,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"nm",
    embedID:"skELDiEYEeg",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c05nm.jpg',
    dis: true,
  },
  {
    id: 35,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"hXZUwAD7FYE",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c22shf.jpg',
    dis: true,
  },
  {
    id: 34,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"I9qIuWbp3MI",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c21shf.jpg',
    dis: true,
  },
  {
    id: 33,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"iZXqkxYVBAY",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c20shf.jpg',
    dis: true,
  },
  {
    id: 32,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"sm",
    embedID:"ZkOVXjyu2B8",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c02sm.jpg',
    dis: true,
  },
  {
    id: 31,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"sm",
    embedID:"WoEMxT3atLI",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c01sm.jpg',
    dis: true,
  },
  {
  
    id: 30,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"wm",
    embedID:"7L28hMKwM10",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c02wm.jpg',
    dis: true,
  },
  {
  id: 29,
  category:"costumes",
  hashtag: "#shaman #female",
  hashtag1: "",
  hashtag2:"wm",
  embedID:"B3AR7TvEBmI",
  title:"",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c01wm.jpg',
  dis: true,
  },
  {
  
    id: 28,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"nm",
    embedID:"gXzw_H0H-Sk",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c04nm.jpg',
    dis: true,
  },
  {
  id: 27,
  category:"costumes",
  hashtag: "#shaman #female",
  hashtag1: "",
  hashtag2:"nm",
  embedID:"sHsAwjz_bME",
  title:"",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c03nm.jpg',
  dis: true,
  },
  {
  
    id: 26,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"nm",
    embedID:"UcqXgZMj6mk",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c02nm.jpg',
    dis: true,
  },
  {
  id: 25,
  category:"costumes",
  hashtag: "#shaman #female",
  hashtag1: "",
  hashtag2:"nm",
  embedID:"hhfJvcfBjj0",
  title:"",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c01nm.jpg',
  dis: true,
  },
  {
    id: 24,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shm",
    embedID:"86HJ7X9A7I0",
    title:"",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c23shm.jpg',
    dis: true,
    },
  {
    id: 23,
    category:"costumes",
    hashtag: "#shaman #male",
    hashtag1: "",
    hashtag2:"shm",
    embedID:"aZVImoaETb0",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c02shm.jpg',
    dis: true,
  },
  {
  id: 22,
  category:"costumes",
  hashtag: "#shaman #female",
  hashtag1: "",
  hashtag2:"shm",
  embedID:"t0cUW-x-3bw",
  title:"",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c01shm.jpg',
  dis: true,
  },
  {
  
    id: 21,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"nf",
    embedID:"Vl3G4IdTWss",
    title:"Outfit 04",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c02nf.jpg',
    dis: true,
  },
  {
  id: 20,
  category:"costumes",
  hashtag: "#shaman #female",
  hashtag1: "",
  hashtag2:"nf",
  embedID:"zcHI228qocU",
  title:"",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c01nf.jpg',
  dis: true,
  },
{
  id: 19,
  category:"costumes",
  hashtag: "#shaman #female",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"H4gsIqkx5Xc",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c19shf.jpg',
  dis: true,
},
{
id: 18,
category:"costumes",
hashtag: "#shaman #female",
hashtag1: "",
hashtag2:"shf",
embedID:"osI6SU81ndg",
title:"",
price:"--",
mediafire: "Download",
mega:"download",
img:'/images/items/c18shf.jpg',
dis: true,
},
{
  id: 17,
  category:"costumes",
  hashtag: "#shaman #female",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"nYWnzXdslbg",
  title:"Outfit 02",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c17shf.jpg',
  dis: true,
},
{
id: 16,
category:"costumes",
hashtag: "#shaman #female",
hashtag1: "",
hashtag2:"shf",
embedID:"efw8oxzdOiE",
title:"Outfit 01",
price:"--",
mediafire: "Download",
mega:"download",
img:'/images/items/c16shf.jpg',
dis: true,
},
  {
    id: 15,
    category:"costumes",
    hashtag: "#shaman #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"t0cUW-x-3bw",
    title:"Outfit 15",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c15shf.jpg',
    dis: true,
  },
  {
    id: 14,
    category:"costumes",
    hashtag: "#ninja #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"B3AR7TvEBmI",
    title:"Outfit 14",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c14shf.jpg',
    dis: true,
  },
  {
    id: 13,
    category:"costumes",
    hashtag: "#ninja #female",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"7E0UPv6i-5I",
    title:"Outfit 13",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c13shf.jpg',
    dis: true,
  },
  {
    id: 12,
    category:"costumes",
    hashtag: "#shaman #male #shaman #female",
    hashtag1: "couple",
    hashtag2:"shf",
    embedID:"0E_LTaoxBwo",
    title:"Outfit 12",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c12shf.jpg',
    dis: true,
  },
  {
    id: 11,
    category:"costumes",
    hashtag: "#war #male #shaman female",
    hashtag1: "couple",
    hashtag2:"shf",
    embedID:"zNAsHtlz9IQ",
    title:"Outfit 11",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c11shf.jpg',
    dis: true,
  },
  {
    id: 10,
    category:"costumes",
    hashtag: "#ninja #male",
    hashtag1: "",
    hashtag2:"shf",
    embedID:"iM6aQSejsvE",
    title:"Outfit 10",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/c10shf.jpg',
    dis: true,
  },
  {
  id: 9,
  category:"costumes",
  hashtag: "#shaman #female #ninja #male",
  hashtag1: "#couple",
  hashtag2:"shf",
  embedID:"iM6aQSejsvE",
  title:"Outfit 09",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c09shf.jpg',
  dis: true,
},
{
  id: 8,
  category:"costumes",
  hashtag: "#shaman #female",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"nBU5xi25Zm4",
  title:"Outfit 08",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c08shf.jpg',
  dis: true,
},
{
id: 7,
category:"costumes",
hashtag: "#shaman #female",
hashtag1: "",
hashtag2:"shf",
embedID:"sLNAMD0Jtkc",
title:"Outfit 07",
price:"--",
mediafire: "Download",
mega:"download",
img:'/images/items/c07shf.jpg',
dis: true,
},
{
  id: 6,
  category:"costumes",
  hashtag: "#shaman #female",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"0eYpE6yoTvw",
  title:"Outfit 06",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c06shf.jpg',
  dis: true,
},
{
id: 5,
category:"costumes",
hashtag: "#shaman #female",
hashtag1: "",
hashtag2:"shf",
embedID:"5mMwOlaemPw",
title:"Outfit 05",
price:"--",
mediafire: "Download",
mega:"download",
img:'/images/items/c05shf.jpg',
dis: true,
},
{
  id: 4,
  category:"costumes",
  hashtag: "#shaman #female",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"s1x_IMz0xR4",
  title:"Outfit 04",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c04shf.jpg',
  dis: true,
},
{
id: 3,
category:"costumes",
hashtag: "#shaman #female",
hashtag1: "",
hashtag2:"shf",
embedID:"WA91bgDSwE4",
title:"Outfit 03",
price:"--",
mediafire: "Download",
mega:"download",
img:'/images/items/c03shf.jpg',
dis: true,
},
{
  id: 2,
  category:"costumes",
  hashtag: "#shaman #female",
  hashtag1: "",
  hashtag2:"shf",
  embedID:"Z0Z1ykqtpF4",
  title:"Outfit 02",
  price:"--",
  mediafire: "Download",
  mega:"download",
  img:'/images/items/c02shf.jpg',
  dis: true,
},
{
id: 1,
category:"costumes",
hashtag: "#shaman #female",
hashtag1: "",
hashtag2:"shf",
embedID:"f2r_QX-nu44",
title:"Outfit 01",
price:"--",
mediafire: "Download",
mega:"download",
img:'/images/items/c01shf.jpg',
dis: true,
},
];

export const renders=[

];
export const monsters=[
  {
    id: 3,
    category:"stones",
    hashtag: "#monster",
    hashtag1: "#boss",
    hashtag2:"",
    embedID:"K34DrGUrnh0",
    title:"Moster Boss 01",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/custom_monster.jpg',
    dis: true,
  },
  {
    id: 2,
    category:"stones",
    hashtag: "#monster",
    hashtag1: "#boss",
    hashtag2:"",
    embedID:"K34DrGUrnh0",
    title:"Moster Boss 01",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/monster002.jpg',
    dis: true,
  },
  {
    id: 1,
    category:"stones",
    hashtag: "#monster",
    hashtag1: "#boss",
    hashtag2:"",
    embedID:"K34DrGUrnh0",
    title:"Moster Boss 01",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/monster001.jpg',
    dis: true,
  },
];
export const bosses=[
  {
    id: 2,
    category:"stones",
    hashtag: "#monster",
    hashtag1: "#boss",
    hashtag2:"",
    embedID:"6-cidVC-A8Q",
    title:"Moster Boss 01",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/custom_boss.jpg',
    dis: true,
  },
  {
    id: 1,
    category:"stones",
    hashtag: "#monster",
    hashtag1: "#boss",
    hashtag2:"",
    embedID:"6-cidVC-A8Q",
    title:"Moster Boss 01",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/boss001.jpg',
    dis: true,
  },
];
export const npcs=[
  {
    id: 10,
    category:"npc",
    hashtag: "#monster",
    hashtag1: "#boss",
    hashtag2:"",
    embedID:"FsVPfmgjLks",
    title:"Moster Boss 01",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/custom_npc.jpg',
    dis: true,
  },
  {
    id: 9,
    category:"npc",
    hashtag: "#monster",
    hashtag1: "#boss",
    hashtag2:"",
    embedID:"pTOOfG5KvXc",
    title:"Moster Boss 01",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/npc009.jpg',
    dis: true,
  },
  {
    id: 8,
    category:"npc",
    hashtag: "#monster",
    hashtag1: "#boss",
    hashtag2:"",
    embedID:"pTOOfG5KvXc",
    title:"Moster Boss 01",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/npc008.jpg',
    dis: true,
  },
  {
    id: 7,
    category:"npc",
    hashtag: "#monster",
    hashtag1: "#boss",
    hashtag2:"",
    embedID:"pTOOfG5KvXc",
    title:"Moster Boss 01",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/npc007.jpg',
    dis: true,
  },
  {
    id: 6,
    category:"npc",
    hashtag: "#monster",
    hashtag1: "#boss",
    hashtag2:"",
    embedID:"pTOOfG5KvXc",
    title:"Moster Boss 01",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/npc006.jpg',
    dis: true,
  },
  {
    id: 5,
    category:"npc",
    hashtag: "#monster",
    hashtag1: "#boss",
    hashtag2:"",
    embedID:"pTOOfG5KvXc",
    title:"Moster Boss 01",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/npc005.jpg',
    dis: true,
  },
  {
    id: 4,
    category:"npc",
    hashtag: "#monster",
    hashtag1: "#boss",
    hashtag2:"",
    embedID:"pTOOfG5KvXc",
    title:"Moster Boss 01",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/npc004.jpg',
    dis: true,
  },
  {
    id: 3,
    category:"npc",
    hashtag: "#monster",
    hashtag1: "#boss",
    hashtag2:"",
    embedID:"pTOOfG5KvXc",
    title:"Moster Boss 01",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/npc003.jpg',
    dis: true,
  },
  {
    id: 2,
    category:"npc",
    hashtag: "#monster",
    hashtag1: "#boss",
    hashtag2:"",
    embedID:"pTOOfG5KvXc",
    title:"Moster Boss 01",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/npc002.jpg',
    dis: true,
  },
  {
    id: 1,
    category:"npc",
    hashtag: "#monster",
    hashtag1: "#boss",
    hashtag2:"",
    embedID:"FsVPfmgjLks",
    title:"Moster Boss 01",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/npc001.jpg',
    dis: true,
  },
];
export const stones=[
  {
    id: 4,
    category:"stones",
    hashtag: "#metinstone",
    hashtag1: "#minecraft",
    hashtag2:"",
    embedID:"gJ__xsKcJak",
    title:"Minecraft Ore Stons",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/custom_stone.jpg',
    dis: true,
  },
  {
    id: 3,
    category:"stones",
    hashtag: "#metinstone",
    hashtag1: "#minecraft",
    hashtag2:"",
    embedID:"EN0n9tyUYeU",
    title:"Minecraft Ore Stons",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/stone003.jpg',
    dis: true,
  },
  {
    id: 2,
    category:"stones",
    hashtag: "#metinstone",
    hashtag1: "#minecraft",
    hashtag2:"",
    embedID:"gJ__xsKcJak",
    title:"Minecraft Ore Stons",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/stone002.jpg',
    dis: true,
  },
  {
    id: 1,
    category:"stones",
    hashtag: "#metinstone",
    hashtag1: "#minecraft",
    hashtag2:"",
    embedID:"5mjykRIuKV4",
    title:"Minecraft Ore Stons",
    price:"--",
    mediafire: "Download",
    mega:"download",
    img:'/images/items/stone001.jpg',
    dis: true,
  },
];

export const orders=[
  {
    id: 1,
    category:"order",
    hashtag: "#inProgress",
    hashtag1: "#orderOnly",
    hashtag2:"",
    embedID:"q3s0sHMeHSg",
    title:"Sitting animation",
    price:"30 EUR",
    mediafire: "Download",
    mega:"download",
    img:'/images/none.png',
    dis: true,
  },
  {
  id: 2,
  category:"order",
  hashtag: "#inProgress",
  hashtag1: "#orderOnly",
  hashtag2:"",
  embedID:"7Iy1OEmcnmg",
  title:"Cash Cash Emote",
  price:"30 EUR",
  mediafire: "Download",
  mega:"download",
  img:'/images/none.png',
  dis: true,
},
{
  id: 3,
  category:"order",
  hashtag: "#inProgress",
  hashtag1: "#orderOnly",
  hashtag2:"",
  embedID:"wbk6EEkpSE4",
  title:"I'm So Excited",
  price:"25 EUR",
  mediafire: "Download",
  mega:"download",
  img:'/images/none.png',
  dis: true,
},
{
  id: 4,
  category:"order",
  hashtag: "#inProgress",
  hashtag1: "#orderOnly",
  hashtag2:"#interactive",
  embedID:"g1G57ORB-s4",
  title:"Hug Idle Animation",
  price:"50 EUR",
  mediafire: "Download",
  mega:"download",
  img:'/images/none.png',
  dis: true,
}, 
];

export const fullsets = [
  {
    id: 9,
    title: "Animal Print Set",
    embedID: "PXQ82X9XUkc",
    prices: {
      costumes: "100",
      weapons: "25",
      mount: "15",
      pet: "10",
      wings: ""
    },
    shiningPrices: {
      costumes: "",
      weapons: "" // only for weapons
    },
    wolfmanPrice: "", // costumes only
    clawsPrice: "", // weapons only
    images: {
      costumes: "/images/fullsets/animal_print_costumes.webp",
      weapons: "/images/fullsets/animal_print_weapons.webp",
      mount: "/images/fullsets/animal_print_mount.webp",
      pet: "/images/fullsets/animal_print_pet.webp",
      wings: ""
    }
  },
  {
    id: 8,
    title: "Summer 2026 Set",
    embedID: "DqIyVaGztGg",
    prices: {
      costumes: "75",
      weapons: "25",
      mount: "15",
      pet: "10",
      wings: ""
    },
    shiningPrices: {
      costumes: "+10",
      weapons: "+10" // only for weapons
    },
    wolfmanPrice: "", // costumes only
    clawsPrice: "", // weapons only
    images: {
      costumes: "/images/fullsets/summer2026_costumes.webp",
      weapons: "/images/fullsets/summer2026_weapons.webp",
      mount: "/images/fullsets/summer2026_mount.webp",
      pet: "/images/fullsets/summer2026_pet.webp",
      wings: ""
    }
  },
  {
    id: 7,
    title: "Xmas 2025 Set",
    embedID: "ZZY9z2Oi7Z0",
    prices: {
      costumes: "60",
      weapons: "20",
      mount: "15",
      pet: "10",
      wings: ""
    },
    shiningPrices: {
      costumes: "+10",
      weapons: "" // only for weapons
    },
    wolfmanPrice: "+10", // costumes only
    clawsPrice: "+5", // weapons only
    images: {
      costumes: "/images/fullsets/xmas2025_costumes.webp",
      weapons: "/images/fullsets/xmas2025_weapons.webp",
      mount: "/images/fullsets/xmas2025_mount.webp",
      pet: "/images/fullsets/xmas2025_pet.webp",
      wings: ""
    }
  },
  {
    id: 6,
    title: "Turtleneck Set",
    embedID: "ASqR4czvNQI",
    prices: {
      costumes: "60",
      weapons: "20",
      mount: "15",
      pet: "15",
      wings: ""
    },
    shiningPrices: {
      costumes: "",
      weapons: ""
    },
    wolfmanPrice: "", // no wolfman
    clawsPrice: "",   // no claws
    images: {
      costumes: "/images/fullsets/turtleneck_costumes.webp",
      weapons: "/images/fullsets/turtleneck_weapons.webp",
      mount: "/images/fullsets/turtleneck_mount.webp",
      pet: "/images/fullsets/turtleneck_pet.webp",
      wings: ""
    }
  },
  {
    id: 5,
    title: "Gold Royal Set",
    embedID: "XgD7JsSFiok",
    prices: {
      costumes: "70",
      weapons: "20",
      mount: "15",
      pet: "10",
      wings: "10"
    },
    shiningPrices: {
      costumes: "+10",
      weapons: "+10"
    },
    wolfmanPrice: "+10", // costumes only
    clawsPrice: "+5", // weapons only
    images: {
      costumes: "/images/fullsets/gold_royal_costumes.webp",
      weapons: "/images/fullsets/gold_royal_weapons.webp",
      mount: "/images/fullsets/gold_royal_mount.webp",
      pet: "/images/fullsets/gold_royal_pet.webp",
      wings: "/images/fullsets/gold_royal_sash.webp"
    }
  },
  {
    id: 4,
    title: "School 2024 Set",
    embedID: "wcRi6fWll9Q",
    prices: {
      costumes: "60",
      weapons: "",
      mount: "15",
      pet: "10",
      wings: ""
    },
    shiningPrices: {
      costumes: "",
      weapons: ""
    },
    wolfmanPrice: "+10", // costumes only
    clawsPrice: "",   // no claws
    images: {
      costumes: "/images/fullsets/school2024_costumes.webp",
      weapons: "",
      mount: "/images/fullsets/school2024_mount.webp",
      pet: "/images/fullsets/school2024_pet.webp",
      wings: ""
    }
  },
  {
    id: 3,
    title: "Sunny Blaze Set",
    embedID: "HI-6xFmxL4M",
    prices: {
      costumes: "60",
      weapons: "20",
      mount: "15",
      pet: "10",
      wings: "10"
    },
    shiningPrices: {
      costumes: "+10",
      weapons: "+10"
    },
    wolfmanPrice: "+10", // costumes only
    clawsPrice: "+5", // weapons only
    images: {
      costumes: "/images/fullsets/sunny_blaze_costumes.webp",
      weapons: "/images/fullsets/sunny_blaze_weapons.webp",
      mount: "/images/fullsets/sunny_blaze_mount.webp",
      pet: "/images/fullsets/sunny_blaze_pet.webp",
      wings: "/images/fullsets/sunny_blaze_wings.webp"
    }
  },
  {
    id: 2,
    title: "Blue Blaze Set",
    embedID: "HI-6xFmxL4M",
    prices: {
      costumes: "60",
      weapons: "20",
      mount: "15",
      pet: "10",
      wings: "10"
    },
    shiningPrices: {
      costumes: "+10",
      weapons: "+10"
    },
    wolfmanPrice: "+10", // costumes only
    clawsPrice: "+5", // weapons only
    images: {
      costumes: "/images/fullsets/blue_blaze_costumes.webp",
      weapons: "/images/fullsets/blue_blaze_weapons.webp",
      mount: "/images/fullsets/blue_blaze_mount.webp",
      pet: "/images/fullsets/blue_blaze_pet.webp",
      wings: "/images/fullsets/blue_blaze_wings.webp"
    }
  },
  {
    id: 1,
    title: "Set 01",
    embedID: "3ZU5YZqoaWY",
    prices: {
      costumes: "60",
      weapons: "20",
      mount: "15",
      pet: "10",
      wings: "10"
    },
    shiningPrices: {
      costumes: "+10",
      weapons: "+10"
    },
    wolfmanPrice: "", // costumes only
    clawsPrice: "",   // weapons only
    images: {
      costumes: "/images/fullsets/set01_costumes.webp",
      weapons: "/images/fullsets/set01_weapons.webp",
      mount: "/images/fullsets/set01_mount.webp",
      pet: "/images/fullsets/set01_pet.webp",
      wings: "/images/fullsets/set01_wings.webp"
    }
  }
];
export const dances = [
  {
    id: 19,
    title: "Drunk Animation",
    embedID: "NmfErm9cV5s",
    image: "/images/animations/animations_drunk.webp",
    price: 40, // optional, for price overlay
  },
  {
    id: 18,
    title: "Mogosu Move",
    embedID: "CW3kyMBG8fs",
    image: "/images/animations/animations_mogosu.webp",
    price: 25, // optional, for price overlay
  },
  {
    id: 17,
    title: "Made in Ro Dance",
    embedID: "Y54HKzVGIZM",
    image: "/images/animations/animations_madeinro.webp",
    price: 30, // optional, for price overlay
  },
  {
    id: 16,
    title: "Sitting Animation",
    embedID: "JVSp3SI7uBo",
    image: "/images/animations/animations_sitting.webp",
    price: 30, // optional, for price overlay
  },
  {
    id: 15,
    title: "Proposal Animation",
    embedID: "lt7cRLUVVZY",
    image: "/images/animations/animations_proposal.webp",
    price: 20, // optional, for price overlay
  },
    {
    id: 14,
    title: "Jump Animation",
    embedID: "dYYOva3pbgA",
    image: "/images/animations/animations_jump.webp",
    price: 20, // optional, for price overlay
  },
  {
    id: 13,
    title: "Cash Animation",
    embedID: "ymDp2E543Vw",
    image: "/images/animations/animations_cash.webp",
    price: 30, // optional, for price overlay
  },
  {
    id: 12,
    title: "Shuffle Dance",
    embedID: "Mlcva7Flagc",
    image: "/images/animations/animations_shuffle.webp",
    price: 25, // optional, for price overlay
  },
    {
    id: 11,
    title: "Hip Sway Dance",
    embedID: "rUevP_HHb1U",
    image: "/images/animations/animations_hipsway.webp",
    price: 25, // optional, for price overlay
  },
    {
    id: 10,
    title: "Samba Dance",
    embedID: "8tHmaHj7JYE",
    image: "/images/animations/animations_samba.webp",
    price: 15, // optional, for price overlay
  },
  {
    id: 9,
    title: "Sunt O Forta Dance",
    embedID: "qrJpkVllAoY",
    image: "/images/animations/animations_suntoforta.webp",
    price: 25, // optional, for price overlay
  },
    {
    id: 8,
    title: "Boschetarii Dance",
    embedID: "l07-faRt5mo",
    image: "/images/animations/animations_boschetarii.webp",
    price: 25, // optional, for price overlay
  },
  {
    id: 7,
    title: "Flag Animation",
    embedID: "obz0pUjdUyU",
    image: "/images/animations/animations_flag.webp",
    price: 30, // optional, for price overlay
  },
    {
    id: 6,
    title: "Candle Animation",
    embedID: "Am5qndcdn0w",
    image: "/images/animations/animations_candle.webp",
    price: 25, // optional, for price overlay
  },
    {
    id: 5,
    title: "Orange Justice Dance",
    embedID: "hVpj2Of_P90",
    image: "/images/animations/animations_orangejustice.webp",
    price: 25, // optional, for price overlay
  },
  {
    id: 4,
    title: "Fishing Dance",
    embedID: "z8LLMXDPQz0",
    image: "/images/animations/animations_fishing.webp",
    price: 20, // optional, for price overlay
  },
    {
    id: 3,
    title: "Party Dance",
    embedID: "bsgEfpVWVHo",
    image: "/images/animations/animations_party.webp",
    price: "0", // optional, for price overlay
  },

    {
    id: 2,
    title: "Candy Shop Dance",
    embedID: "BEeS1nIwSBM",
    image: "/images/animations/animations_candy.webp",
    price: "0", // optional, for price overlay
  },


  {
    id: 1,
    title: "Macarena Dance",
    embedID: "rfkv61Jcuts",
    image: "/images/animations/animations_macarena.webp",
    price: "0", // optional, for price overlay
  },
];